import { workerVisitLockWorkplaceContract } from "@clipboard-health/contract-home-health-api";
import { post } from "@src/appV2/api/parsedApi";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib/analytics";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { invalidateWorkerLockQueries } from "./invalidateWorkerLockQueries";

interface CreateWorkerLockParams {
  workplaceId: string;
  workerId: string;
  lockReason: string;
  unlockCondition: string;
}

export function useCreateWorkerLock() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: CreateWorkerLockParams) => {
      const { workplaceId, workerId, lockReason, unlockCondition } = params;
      const url = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/workplaces/${workplaceId}/worker-visit-locks`;

      const response = await post({
        url,
        data: { workerId, lockReason, unlockCondition },
        bodySchema: workerVisitLockWorkplaceContract.createWorkerVisitLock.body,
        responseSchema: workerVisitLockWorkplaceContract.createWorkerVisitLock.responses[201],
      });

      return response.data;
    },
    onSuccess: () => {
      invalidateWorkerLockQueries(queryClient);
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.CREATE_WORKER_LOCK_FAILURE,
    },
  });
}
